import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';

const REDIRECT_KEY = 'calbucura.postLoginRedirect';

interface ProtectedRouteProps {
  requireRole?: string | string[];
}

export function ProtectedRoute({ requireRole }: ProtectedRouteProps) {
  const { status, me } = useAuth();
  const location = useLocation();

  if (status === 'loading') {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <p className="text-gray-500">Cargando…</p>
      </div>
    );
  }

  if (status !== 'authenticated' || !me) {
    sessionStorage.setItem(REDIRECT_KEY, location.pathname + location.search);
    return <Navigate to="/login" replace />;
  }

  if (requireRole) {
    const required = Array.isArray(requireRole) ? requireRole : [requireRole];
    // super_admin se valida por usuario.tipo_cuenta, NO por persona_roles
    // (coherente con backend dependencies.require_super_admin). Las
    // cuentas super_admin son operacionales y NO tienen filas en
    // persona_roles porque no representan a una persona con roles.
    const tieneAlgunRol = required.some((rol) => {
      if (rol === 'super_admin') return me.usuario.tipo_cuenta === 'super_admin';
      return me.roles_vigentes.includes(rol);
    });
    if (!tieneAlgunRol) {
      return <Navigate to="/sin-permiso" replace />;
    }
  }

  return <Outlet />;
}

export { REDIRECT_KEY };
